import { Button, FormControlLabel, Grid, Radio, RadioGroup, Typography } from "@mui/material";
import React from "react";
import { Field, Form } from "react-final-form";
import { useTranslation } from "react-i18next";
import { TextFieldCustom } from "../../components/FormElements";
import Container from "../../components/Container";
import PublicPage from "../PublicPage";

export default function VerificationView(props) {
    const { t } = useTranslation();
    const { method, setMethod,message } = props

    return (
        <PublicPage message={message} showProcessing={props.showProcessing} confirm={props.confirm}>
            <Grid item xs={12} marginTop={4} container justifyContent={'center'} alignItems={'center'}>
                <Typography variant='h4' textAlign={'center'}>{t('two_step_authentication')}</Typography>
                <Grid xs={12} sm={10} item>
                    <Typography marginTop={2} variant='body2' textAlign={'center'}>{method =='TOTP' ? t('two_step_authentication_otp_desc') : t('two_step_authentication_backupcode_desc')}</Typography>
                </Grid>
            </Grid>
            <Grid item xs={12} marginTop={4}>
                <Grid item xs={12}>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit }) => (
                            <Grid item xs={12}>
                                 <RadioGroup row value={method} onChange={(e, val) => setMethod(val)}>
                                    <FormControlLabel value="TOTP" control={<Radio />} label="OTP" />
                                    <FormControlLabel value="BACKUP_CODE" control={<Radio />} label={t('backup_code')} />
                                </RadioGroup>
                                <Grid item xs={12}>
                                    <Field
                                        name="code"
                                        component={TextFieldCustom}
                                        placeholder={method=='TOTP' ? t('enter_verify_code') : t('enter_backup_code')}
                                        isEdit={true}
                                    />
                                </Grid>
                               
                                <Grid item xs={12} marginTop={6}>
                                    <Button id="verification/btnSubmit" fullWidth size='large' variant='contained' onClick={handleSubmit}>{t('btn_submit')}</Button>
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
            <Grid item xs={12} marginTop={2}>
                <Button id="verification/btnSubmit" fullWidth size='large' variant='text' onClick={props.onCancelVerify}>Cancel</Button>
            </Grid>
        </PublicPage>
    )
}